import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import AssetImageComponent from './asset-image-component';

export interface AssetImageOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    assetImage: {
      insertAssetImage: (options: {
        sessionId: string;
        filename: string;
        alt?: string;
      }) => ReturnType;
    };
  }
}

export const AssetImage = Node.create<AssetImageOptions>({
  name: 'assetImage',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  group: 'block',

  atom: true,

  addAttributes() {
    return {
      sessionId: {
        default: null,
        parseHTML: element => element.getAttribute('data-session-id'),
        renderHTML: attributes => {
          if (!attributes.sessionId) {
            return {};
          }
          return {
            'data-session-id': attributes.sessionId,
          };
        },
      },
      filename: {
        default: null,
        parseHTML: element => element.getAttribute('data-filename'),
        renderHTML: attributes => {
          if (!attributes.filename) {
            return {};
          }
          return {
            'data-filename': attributes.filename,
          };
        },
      },
      alt: {
        default: null,
        parseHTML: element => element.getAttribute('data-alt'),
        renderHTML: attributes => {
          if (!attributes.alt) {
            return {};
          }
          return {
            'data-alt': attributes.alt,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="asset-image"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        'data-type': 'asset-image',
      }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AssetImageComponent);
  },

  addCommands() {
    return {
      insertAssetImage:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          });
        },
    };
  },
});